import React, { PureComponent, PropTypes } from 'react';
import ReactDOM from 'react-dom';
import classNames from 'classnames';

export default class BootstrapDropDown extends PureComponent {
  static propTypes = {
    title: PropTypes.string.isRequired
  };

  componentDidMount(){
    this.setState({title: this.props.title, open: false});
    document.addEventListener('click', this.handleDocumentClick.bind(this), true);
  }

  componentWillUnmount() {
      document.removeEventListener('click', this.handleDocumentClick.bind(this), true);
  }  

  constructor(props) {
    super(props)
    this.state = {
      open: false
    }

    this.toggleOpen = this.toggleOpen.bind(this);
  }

  handleDocumentClick(e) {
    const domNode = this._node;
    if (!domNode || !domNode.contains(e.target)) {
      // Outside
      if (this.state.open) {
        this.setState({open: false});
      }
    }
  }  

  toggleOpen(e) {
    e.stopPropagation();
    this.setState({open: !this.state.open})
  }

  renderChildren() {
    return React.Children.map(
      this.props.children,
      child => React.cloneElement(
        child,
        {
          ...child.props,
          onClick: e => {
            this.toggleOpen(e);
            child.props.onClick && child.props.onClick(e);
          }
      })
    )
  }

  render() {
    const { title } = this.props;
    const { open } = this.state;
    return (
      <li
        ref={c => {
          this._node = ReactDOM.findDOMNode(c)
        }}
        className={classNames("nav-item dropdown", { show : open })}
      >
        <a className="nav-link dropdown-toggle" onClick={this.toggleOpen}>
          {title}
        </a>
        <div className="dropdown-menu">
          {this.renderChildren()}
        </div>
      </li>
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/BootstrapDropDown.js